const EN_CA = require('./en-ca');
const EN_UK = require('./en-uk');
const EN_US = require('./en-us');
module.exports = {
  'en-ca': EN_CA,
  'en-uk': EN_UK,
  'en-us': EN_US
};
